export enum ExternalFinanceReferenceSource {
  AGL_PAYMENT_MANIFEST = 'AGL_PAYMENT_MANIFEST',
  AGL_BILL_CLAIM = 'AGL_BILL_CLAIM',
  AGL_EXTERNAL_PAYMENT_REQUEST = 'AGL_EXTERNAL_PAYMENT_REQUEST',
}
